import { api_GET, api_POST, api_PUT, api_DELETE } from './_api';

const ranking_api = {
    Residuos: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Ranking/Residuos`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Bairros: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Ranking/Bairros`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Geradores: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Ranking/Geradores`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Destinos: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Ranking/Destinos`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Transportadores: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Ranking/Transportadores`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default ranking_api;